import {
    init as initAmplitude,
    getDeviceId as getDeviceIdFromAmplitude,
    setUserId as setUserIdToAmplitude,
    track as trackToAmplitude,
    setOptOut as setOptOutFromAmplitude,
    identify,
    Identify
} from '@amplitude/analytics-browser';
import { subscribe } from './event-logger';
import { AMPLITUDE_EVENT_TYPES, EVENT_TYPES } from './event-types';

const amplitudeTracker = {
    AMPLITUDE_DEVICE_ID_KEY: 'amplitudeDeviceId',
    optOut: false,

    init(apiKey) {
        const deviceId = amplitudeTracker.getDeviceIdFromStorage();
        const optOut = amplitudeTracker.getOptOutStatusFromCookies();

        amplitudeTracker.optOut = optOut;

        initAmplitude(apiKey, undefined, {
            includeUtm: true,
            minIdLength: 1,
            optOut,
            ...(Boolean(deviceId) ? {deviceId} : {}),
        });
    },

    getDeviceIdFromStorage() {
        return localStorage.getItem(amplitudeTracker.AMPLITUDE_DEVICE_ID_KEY);
    },

    setDeviceIdToStorage(deviceId = '') {
        if (deviceId) {
            localStorage.setItem(amplitudeTracker.AMPLITUDE_DEVICE_ID_KEY, deviceId);
        }
    },

    getDeviceId() {
        let deviceId = amplitudeTracker.getDeviceIdFromStorage();
    
        if (!deviceId) {
            deviceId = getDeviceIdFromAmplitude();
    
            amplitudeTracker.setDeviceIdToStorage(deviceId);
        }

        return deviceId || '';
    },

    setUserId(userId) {
        setUserIdToAmplitude(userId ? `${userId}` : userId);
    },

    track(eventType, eventProperties = {}) {
        const optOut = amplitudeTracker.getOptOutStatusFromCookies();

        if (amplitudeTracker.optOut !== optOut) {
            amplitudeTracker.setOptOut(optOut);
        }

        trackToAmplitude(eventType, eventProperties);
    },

    reset() {
        amplitudeTracker.setUserId(undefined);
    },

    setOptOut(optOut) {
        amplitudeTracker.optOut = optOut;

        setOptOutFromAmplitude(optOut);
    },

    getOptOutStatusFromCookies() {
        const consentPerformance = window.cookieyes?._ckyConsentStore?.get?.('performance');

        if (!consentPerformance) {
            return false;
        }

        return consentPerformance !== 'yes';
    },

    setUserProperties(identifyData) {
        identify(identifyData);
    }
}

subscribe((eventType, eventProperties) => {
    if (eventType === EVENT_TYPES.USER_ID) {
        return amplitudeTracker.setUserId(eventProperties);
    }

    if (eventType === EVENT_TYPES.USER_PROPERTIES) {
        const identifyData = new Identify();

        Object.entries(eventProperties).map(property => identifyData.set(...property));
    
        return amplitudeTracker.setUserProperties(identifyData);
    }

    if (AMPLITUDE_EVENT_TYPES.hasOwnProperty(eventType)) {
        if (typeof AMPLITUDE_EVENT_TYPES[eventType] === 'function') {
            return amplitudeTracker.track(AMPLITUDE_EVENT_TYPES[eventType](eventProperties));
        }

        amplitudeTracker.track(AMPLITUDE_EVENT_TYPES[eventType], eventProperties);
    }
});

export {
    amplitudeTracker
}
